<template>
  <el-table :data="messages" size="mini" @expand-change="cellHandler">
    <el-table-column type="expand">
      <template slot-scope="props">
        <span>{{ props.row.message__describe }}</span>
        <el-link
          @click="downFile(file.key)"
          v-for="(file,index) in props.row.message__files"
          :key="index"
          type="primary"
          icon="el-icon-download"
        >{{file.name}}</el-link>
      </template>
    </el-table-column>
    <el-table-column label="标题">
      <template slot-scope="scope">
        <template v-if="scope.row.read_time">
          <i class="el-icon-ali-xinfengdakai"></i>
        </template>
        <template v-else>
          <i class="el-icon-ali-weidudianjihou"></i>
        </template>
        {{scope.row.message__title}}
      </template>
    </el-table-column>
    <el-table-column prop="message__create_user__name" label="发送人"></el-table-column>
    <el-table-column prop="message__create_time" label="时间"></el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button-group>
          <el-button
            size="mini"
            icon="el-icon-ali-biaojiyidu"
            @click="markMessage(scope.row, false)"
          ></el-button>
          <el-button size="mini" icon="el-icon-ali-delete" @click="markMessage(scope.row, true)"></el-button>
        </el-button-group>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import global_ from "../../global";
import COS from "cos-js-sdk-v5";
var Bucket = "xxcj-1256610687";
var Region = "ap-shanghai";

const api_for_vue = global_.api_user;
export default {
  name: "message",
  props: ["rkey"],
  created() {
    this.queryMessage();
  },
  data() {
    return {
      messages: []
    };
  },
  methods: {
    downFile(key) {
      let _params = {
        servicename: "get_credential"
      };
      this.axios
        .get(global_.api_xmgl, {
          params: _params
        })
        .then(response => {
          let cos = new COS({
            getAuthorization: function(options, callback) {
              callback({
                TmpSecretId: response.data.resultinfo.tmpSecretId,
                TmpSecretKey: response.data.resultinfo.tmpSecretKey,
                XCosSecurityToken: response.data.resultinfo.sessionToken,
                ExpiredTime: response.data.resultinfo.expiredTime
              });
            }
          });
          cos.getObjectUrl(
            {
              Bucket: Bucket,
              Region: Region,
              Key: key,
              Sign: true
            },
            function(err, data) {
              if (!err) {
                var downloadUrl =
                  data.Url +
                  (data.Url.indexOf("?") > -1 ? "&" : "?") +
                  "response-content-disposition=attachment"; // 补充强制下载的参数
                window.open(downloadUrl); // 这里是新窗口打开 url，如果需要在当前窗口打开，可以使用隐藏的 iframe 下载，或使用 a 标签 download 属性协助下载
              } else {
                // eslint-disable-next-line no-console
                console.log(err);
              }
            }
          );
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$router.push("/login");
          } else {
            this.$message.error("服务器开小差了");
          }
        });
    },
    queryMessage() {
      let _params = {
        servicename: "get_messages"
      };
      this.axios
        .get(api_for_vue, {
          params: _params
        })
        .then(response => {
          this.messages = response.data.resultinfo;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    cellHandler(row, expandedRows) {
      let _id = row.id;
      function isExpanded(row) {
        return row.id == _id;
      }
      if (expandedRows.findIndex(isExpanded) == -1 && !row.read_time)
        this.markMessage(row, false);
    },
    markMessage(o, del) {
      o.del_flag = del;
      let data = new FormData();
      data.append("servicename", "mark_message");
      data.append("message", JSON.stringify(o));
      this.axios
        .post(api_for_vue, data)
        .then(() => {
          this.queryMessage();
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.$message.error("认证失败");
          } else {
            this.$message.error("服务器开小差了");
          }
        });
    }
  },
  watch: {
    rkey() {
      this.queryMessage();
    }
  }
};
</script>
